'use client'

import Portfolio from './cherylchen/page'

export default function Home() {
  return <Portfolio />
}

// trigger rebuild
